import '../sass/frontend.scss';

import Factory from './frontend/Factory.js';

const generalEventHandler = Factory.getGeneralEventHandler()
generalEventHandler.addCountDownTimer()
    .addTextSliderAnimation()
    .showSearchFieldAndSetFocus()
    .markNewsletterCheckboxDefaultUnchecked()
    .collapseCategoryMenuWhenClickedOutside()
    .avoidButtonFlickeringIssueOnFrontpage()
    .moveCartNoticesElement()
    .expandFrontPageImages()
    .hideGiftPdfCheckboxWhenEmailIsChangedUsingAjax();

// If it's the front page
if (jQuery('body.frontpage').length) {
    // generalEventHandler.addFrontpageSlider();
}

let detailEventHandler = Factory.getDetailEventHandler()
    .disableRightClick()
    .removePlus()
    .productQuantityUpAndDown()
    .replaceButtonSeparator()
    .addCheckMarkToButtons()
    .removeFirstDropdownOption()
    .addWithFrameText()
    .addQualityGuide()
    .updateCustomPrice()
    .showTpReviewsOnClick()
    .setProductSku()
    .showNoFrameTextWhenClickingOnExtraLarge();
    //.addSpinner()
    // .fixViewportSizeIssue();

let frameImageRepo = Factory.getFrameImageRepository();
frameImageRepo.getAll(() => {
    let frameImagePreloader = frameImageRepo.getFrameImagePreloader();
    detailEventHandler.addPosterFrame(frameImagePreloader);
});
